module.exports = __webpack_public_path__ + "img/CNV.70d74225.png";